import { Box, Image, Text } from '@chakra-ui/core';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, Headline } from '../styles/Hero.styles.js';
import Booking from '../util/Booking';
import Navbar from '../util/Navbar';

const ImageGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin: 1rem 0;
`;

export const openBooking = (
  options = undefined,
  ref: string | undefined = undefined
) => {
  let url = `https://booking.heyhomero.com`;

  if (options) {
    // @ts-ignore
    let { bedrooms, bathrooms, type } = options;
    url = url + `?be=${bedrooms}&ba=${bathrooms}&t=${type}`;
  }
  if (ref) {
    url += `${options ? '&' : '?'}ref=${ref}`;
  }
  let a = document.createElement('a');
  a.href = url;
  a.click();
};

export interface HeroProps {
  city: string;
}

export default function Hero({ city }: HeroProps) {
  const [width, setWidth] = useState(window.innerWidth);

  let _setWidth = () => setWidth(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', _setWidth);
    return () => {
      window.removeEventListener('resize', _setWidth);
    };
  }, []);

  return (
    <section className="hero">
      <Navbar type="secondary" />
      <div className="container" style={{ position: 'relative' }}>
        <Headline
          color="#253ec6"
          style={{ fontWeight: 600, marginTop: width < 600 ? '20vh' : '25vh' }}
        >
          {/* Don't stress. <br />
          We'll handle the mess. */}
          House cleaning services {width > 768 ? <br /> : null}{' '}
          <strong style={{ fontWeight: 900 }}>{city}</strong>
        </Headline>
        <Text
          zIndex={1}
          className="description"
          fontSize={'md'}
          w={['100%', '100%', '50%']}
        >
          Homero is a professional home cleaning company that offers quick
          estimates &amp; transparent pricing
        </Text>
        {width <= 768 ? (
          <Button
            onClick={() => openBooking()}
            // @ts-ignore
            hoverBackground="#0093ED"
          >
            Book now
          </Button>
        ) : (
          <Booking openBooking={openBooking} />
        )}
        {width > 1024 ? (
          <Image
            position={'absolute'}
            top={{
              md: '-15%',
            }}
            bottom="0"
            w="70%"
            alt={`Home Cleaning Services in ${city}`}
            right="-15%"
            src={require('../../assets/location-hero.png')}
          />
        ) : null}
        <br />
        <Box mt={[6, 0]}>
          <ImageGroup>
            <img src={require('../../assets/stars.svg').default} alt="Stars" />
            <span style={{ color: 'inherit' }}>Rated 5 stars on</span>
          </ImageGroup>
          <ImageGroup>
            <a
              href="https://goo.gl/maps/tP4bn6RjbRPgcBi99"
              target={'_blank'}
              rel="noopener noreferrer"
            >
              <Image
                h={'24px'}
                w={'72px'}
                src={require('../../assets/google.png')}
                alt="Google"
                loading="eager"
              />
            </a>
            <a
              href="https://www.trustpilot.com/review/heyhomero.com"
              target={'_blank'}
              rel="noopener noreferrer"
            >
              <img
                src={require('../../assets/trustpilot.svg').default}
                alt="Trustpilot"
                loading="eager"
                height={24}
              />
            </a>
            <a
              href="https://www.bark.com/en/us/company/homero/pk8q8/"
              target={'_blank'}
              rel="noopener noreferrer"
            >
              <Image
                loading="eager"
                src={require('../../assets/yelp_logo.png')}
                alt="Yelp"
                h={'22px'}
                w={'auto'}
              />
            </a>
          </ImageGroup>
        </Box>
      </div>
    </section>
  );
}
